<template>
    <main>
        <v-arc :config="config" ref="arcFaceFive" @click="onClick"></v-arc>
        <v-path 
        v-for="(convention, index) in conventions"
        :key="index"
        :config="convention" 
        />
    </main>
</template>

<script>
import {isEmpty} from 'lodash';
export default {
    name: "faceFive",
    props:['config', 'teeth', 'appliedConventions'],
    methods : {
        onClick(){
            if(isEmpty(this.appliedConventions)){
                this.$emit('selected', {
                    faceCode : 'F5',
                    dentNumber : this.teeth.number,
                    teethInfo: this.teeth
                });
            }
        }
    },
    computed:{
        conventions(){
            return this.appliedConventions.map(c => {
                return {
                    fill:c.conventionInfo.fill,
                    scaleX:c.conventionInfo.scaleX,
                    scaleY:c.conventionInfo.scaleY,
                    data : c.conventionInfo.svgPath,
                    x : this.$refs.arcFaceFive._props.config.x - 20,
                    y : this.$refs.arcFaceFive._props.config.y - 5,
                }
            })
        }
    }
};
</script>

